<template>
  <div>
    <div v-if="isMobile" class="mobile_orderInfo">
      <div class="tabs">
        <span
          @click="showOrder = true"
          :class="showOrder ? 'infoBtn active' : 'infoBtn'"
          >订单信息</span
        >
        <span
          @click="showOrder = false"
          :class="!showOrder ? 'infoBtn active' : 'infoBtn'"
          >账户信息</span
        >
      </div>
      <div v-show="!showOrder">
        <div class="info">
          <div>
            <div class="borderB">
              <mt-cell
                to="/editMobilePhone"
                title="手机号码"
                is-link
                :value="personalInfo.mobilePhone"
              ></mt-cell>
            </div>

            <mt-cell
              to="/editPassword"
              title="登录密码"
              is-link
              value="********"
            ></mt-cell>
            <div class="wrap"></div>
            <div @click="goEditBaseInfo">
              <mt-cell title="姓名" :value="personalInfo.name"></mt-cell>
              <mt-cell title="电子邮箱" :value="personalInfo.mailbox"></mt-cell>
              <mt-cell
                title="公司名称"
                :value="personalInfo.companyName"
                is-link
              ></mt-cell>
              <mt-cell title="公司地区">
                {{
                  personalInfo.province === personalInfo.city ||
                  personalInfo.province === "省"
                    ? ""
                    : personalInfo.province
                }}{{ personalInfo.city === "市" ? "" : personalInfo.city
                }}{{
                  personalInfo.area === "区" ? "" : personalInfo.area
                }}</mt-cell
              >
              <div class="borderB">
                <mt-cell
                  title="详细地址"
                  :value="personalInfo.detailedAddress"
                ></mt-cell>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="showOrder" class="list">
        <div v-for="(item, index) in list" :key="item.orderNo" class="item">
          <div class="showInfo">{{ item.createTime }}</div>
          <div class="showInfo">订单编号：{{ item.orderNo }}</div>
          <div>
            <el-collapse-transition>
              <div v-if="item.isShow">
                <div class="goodsInfo">
                  <img
                    :src="require('../../images/x5_goods_white.png')"
                    alt=""
                  />
                </div>
                <div class="table">
                  <div class="title clearfix">
                    <div class="left fl">设备配置</div>
                    <div class="right fr">价格</div>
                  </div>
                  <div
                    v-for="item1 in item.orderDetails.configList"
                    :key="item1.kind"
                    class="item1"
                  >
                    <div class="label">
                      <span style="padding-right:8px"> {{ item1.kind }}</span
                      >({{ item1.config }})
                    </div>
                    <div class="value" v-show="item1.price === '已包含'">
                      {{ item1.price }}
                    </div>
                    <div class="value" v-show="item1.price !== '已包含'">
                      {{ item1.price | priceFilter }}
                    </div>
                  </div>
                </div>
                <div class="priceInfo">
                  <div class="label">设备总价</div>
                  <div class="value">
                    {{ item.orderDetails.price | priceFilter }}
                  </div>
                </div>
                <div style="margin-bottom:14px" class="priceInfo">
                  <div class="label">预付定金</div>
                  <div class="value">{{ 1000 | priceFilter }}</div>
                </div>
              </div>
            </el-collapse-transition>
            <div @click="setIsShow(index)" v-if="!item.isShow" class="isShow">
              <i class="el-icon-circle-plus plusIcon"></i>显示详情
            </div>
            <div v-if="item.isShow" @click="setIsShow(index)" class="isShow">
              <i class="el-icon-remove plusIcon"></i>隐藏详情
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isMobile" class="orderInfo">
      <el-row class="top">
        <el-col class="title" :span="12"
          >您好，{{ this.personalInfo.name }}</el-col
        >
        <el-col class="fr info" :span="12">
          <span
            @click="showOrder = true"
            :class="showOrder ? 'infoBtn pc_active' : 'infoBtn'"
            >订单信息</span
          >
          <span
            @click="showOrder = false"
            :class="!showOrder ? 'infoBtn pc_active' : 'infoBtn'"
            >账户信息</span
          >
          <span @click="loginOut" class="infoBtn">退出登录</span>
        </el-col>
      </el-row>
      <div
        :style="list.length > 0 ? 'border-top: 1px solid #d8d8d8;' : ''"
        v-show="showOrder"
        class="list"
      >
        <el-collapse v-if="list.length > 0" v-model="activeOrder" accordion>
          <el-collapse-item
            v-for="item in list"
            :key="item.orderNo"
            :name="item.orderNo"
          >
            <template slot="title">
              <div style="padding-left:24px;width:100%">
                {{ item.createTime }}
                <div style="padding-left:20px;display:inline-block">
                  订单编号：{{ item.orderNo }}
                </div>
              </div>
            </template>
            <div class="content">
              <div class="left">
                <img :src="require('../../images/x5_goods_white.png')" alt="" />
              </div>
              <div class="right">
                <div class="tableTitle">
                  <div class="item fl">种类</div>
                  <div class="item fr">价格</div>
                  <div class="item">配置</div>
                </div>
                <div
                  class="tableCol"
                  v-for="item1 in item.orderDetails.configList"
                  :key="item1.kind"
                >
                  <div class="item fl">{{ item1.kind }}</div>

                  <div class="item fr">
                    {{ item1.price | priceFilter }}
                  </div>
                  <div class="item ">{{ item1.config }}</div>
                </div>

                <div style="padding:11px 24px">
                  <div class="price">
                    <div class="label">设备总价</div>
                    <div class="value">
                      {{ item.orderDetails.price | priceFilter }}
                    </div>
                  </div>
                  <div style="font-weight:700" class="price">
                    <div class="label">预付定金</div>
                    <div class="value">
                      {{ 1000 | priceFilter }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div v-if="list.length < 1" class="noOrder">
          暂无订单信息，<span @click="goBuy" class="goBuy">去订购</span>
        </div>
      </div>
      <div class="personalContainer" v-show="!showOrder">
        <div class="personalInfo clearfix">
          <div class="title">账户信息</div>
        </div>
        <div class="info">
          <div class="item">
            <div class="label">手机账号</div>
            <div class="value">
              {{ personalInfo.mobilePhone
              }}<img
                class="editClass"
                @click="editInfo('mobilePhone')"
                :src="editImg"
                alt=""
              />
            </div>
          </div>
          <div class="item">
            <div class="label">登录密码</div>
            <div class="value">
              ******<img
                class="editClass"
                @click="editInfo('password')"
                :src="editImg"
                alt=""
              />
            </div>
          </div>
        </div>
        <div style="margin-top:24px" class="personalInfo clearfix">
          <div class="title">基本信息</div>
        </div>
        <div class="info">
          <div class="item">
            <div class="label">姓名</div>
            <div class="value">
              {{ personalInfo.name
              }}<img
                class="editClass"
                @click="editInfo('baseInfo')"
                :src="editImg"
                alt=""
              />
            </div>
          </div>
          <div class="item">
            <div class="label">电子邮箱</div>
            <div v-show="personalInfo.mailbox" class="value">
              {{ personalInfo.mailbox }}
            </div>
            <div v-show="!personalInfo.mailbox" class="noInfo">暂无信息</div>
          </div>

          <div class="item">
            <div class="label">公司名称</div>
            <div v-show="personalInfo.companyName" class="value">
              {{ personalInfo.companyName }}
            </div>
            <div v-show="!personalInfo.companyName" class="noInfo">
              暂无信息
            </div>
          </div>
          <div class="item">
            <div class="label">公司地址</div>
            <div
              v-show="
                personalInfo.province !== '省' || personalInfo.detailedAddress
              "
              class="value"
            >
              {{
                personalInfo.province === personalInfo.city ||
                personalInfo.province === "省"
                  ? ""
                  : personalInfo.province
              }}{{ personalInfo.city === "市" ? "" : personalInfo.city
              }}{{ personalInfo.area === "区" ? "" : personalInfo.area
              }}{{ personalInfo.detailedAddress }}
            </div>
            <div
              v-show="
                personalInfo.province === '省' && !personalInfo.detailedAddress
              "
              class="noInfo"
            >
              暂无信息
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        class="editDialog"
        :visible.sync="editVisible"
        width="550px"
        :show-close="false"
        :before-close="handleCancel"
      >
        <div class="editDialog">
          <div class="title">{{ editTitle }}</div>
          <el-form
            label-position="top"
            ref="form"
            :inline="true"
            :model="personalInfo1"
            :rules="rules"
            class="demo-form-inline"
          >
            <el-form-item
              v-show="editType !== 'baseInfo'"
              prop="password"
              style="width:100%"
              :label="editType !== 'password' ? '登录密码' : '请输入登录密码'"
            >
              <el-input
                show-password
                v-model="personalInfo1.password"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-show="editType === 'password'"
              prop="new_password"
              style="width:100%"
              label="请输入新密码"
            >
              <el-input
                show-password
                v-model="personalInfo1.new_password"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-show="editType === 'password'"
              prop="again_new_password"
              style="width:100%"
              label="再次输入新密码"
            >
              <el-input
                show-password
                v-model="personalInfo1.again_new_password"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="new_mobilePhone"
              style="width:100%"
              v-show="editType === 'mobilePhone'"
              label="新手机号码"
            >
              <el-input
                maxlength="11"
                v-model="personalInfo1.new_mobilePhone"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="code"
              style="width:100%"
              v-show="editType === 'mobilePhone'"
              label="验证码"
            >
              <el-input v-model="personalInfo1.code">
                <template slot="append"
                  ><div
                    v-show="!showCountDown"
                    class="codeLabel"
                    @click="getCode1"
                  >
                    获取验证码
                  </div>
                  <div class="codeLabel" v-show="showCountDown">
                    {{ countDown }}s
                  </div></template
                ></el-input
              >
            </el-form-item>
            <el-form-item
              prop="name"
              v-show="editType === 'baseInfo'"
              style="width:100%"
              label="姓名"
            >
              <el-input v-model="personalInfo1.name"></el-input>
            </el-form-item>
            <el-form-item
              v-show="editType === 'baseInfo'"
              style="width:100%"
              label="电子邮箱"
            >
              <el-input v-model="personalInfo1.mailbox"></el-input>
            </el-form-item>
            <el-form-item
              v-show="editType === 'baseInfo'"
              style="width:100%"
              label="公司名称"
            >
              <el-input v-model="personalInfo1.companyName"></el-input>
            </el-form-item>
            <el-form-item
              v-show="editType === 'baseInfo'"
              style="width:100%"
              label="公司地址"
            >
              <v-distpicker
                :province="personalInfo1.province"
                :city="personalInfo1.city"
                :area="personalInfo1.area"
                @province="onChangeProvince"
                @city="onChangeCity"
                @area="onChangeArea"
              ></v-distpicker>
              <el-input
                style="margin-top:30px"
                v-model="personalInfo1.detailedAddress"
                placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="footer">
            <el-button @click="handleCancel">取消</el-button>
            <el-button
              @click="edit_save"
              :disabled="edit_disabled"
              class="confirm"
              >确定</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import store from "../../store";
import VDistpicker from "v-distpicker";
import { apiGetOrderList } from "../../api/order";
import {
  apiSendCode,
  apiUpdateAccount,
  apiGetAccount,
  apiEditPassword,
  apiUpdateMobilePhone
} from "../../api/index";
import toast from "../../utils/toast";
var timeId;
export default {
  data() {
    return {
      list: [],
      showOrder: !this.$store.state.showAccount, //!this.$store.state.showAccount,
      edit: false,
      personalInfo: {},
      countDown: 60,
      showCountDown: false,
      personalInfo1: {},
      activeOrder: "",
      canSave: false,
      editImg: require("../../images/info/edit.png"),
      editTitle: "",
      editVisible: false,
      editType: false,
      form: {},
      rules: {},
      edit_disabled: false
    };
  },
  watch: {
    personalInfo1: {
      handler: function(newValue) {
        let fault = false;
        Object.keys(newValue).forEach(item => {
          if (!newValue[item]) {
            fault = true;
          }
        });
        this.canSave = !fault;

        let boolean = false;
        switch (this.editType) {
          case "mobilePhone":
            if (
              !newValue.new_mobilePhone ||
              !newValue.password ||
              !newValue.code
            ) {
              boolean = true;
            }
            break;

          case "password":
            if (
              !newValue.new_password ||
              !newValue.password ||
              !newValue.again_new_password
            ) {
              boolean = true;
            }
            break;
          case "baseInfo":
            if (!newValue.name) {
              boolean = true;
            }
            break;
        }
        this.edit_disabled = boolean;
      },
      deep: true
    },
    editType: function(newValue) {
      switch (newValue) {
        case "mobilePhone":
          this.rules = {
            new_mobilePhone: [
              { required: true, message: "请输入手机号码", trigger: "blur" }
              // {
              //   pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/,
              //   message: "请输入正确的手机号码"
              // }
            ],
            password: [
              {
                required: true,
                message: "请输入登录密码",
                trigger: "blur"
              }
            ],
            code: { required: true, message: "请输入验证码", trigger: "blur" }
          };
          break;
        case "password":
          this.rules = {
            password: [
              {
                required: true,
                message: "请输入登录密码",
                trigger: "blur"
              },
              {
                min: 6,
                max: 18,
                message: "密码长度为6到18位"
              }
            ],
            new_password: [
              {
                required: true,
                message: "请输入新密码",
                trigger: "blur"
              },
              {
                min: 6,
                max: 18,
                message: "密码长度为6到18位"
              }
            ],
            again_new_password: [
              {
                required: true,
                message: "请再次输入新密码",
                trigger: "blur"
              },
              {
                min: 6,
                max: 18,
                message: "密码长度为6到18位"
              }
            ]
          };
          break;
        case "baseInfo":
          this.rules = {
            name: { required: true, message: "请输入姓名", trigger: "blur" }
          };
          break;
      }
    }
  },
  components: { VDistpicker },
  computed: {
    isMobile: function() {
      return store.state.isMobile;
    }
  },
  methods: {
    goEditBaseInfo() {
      this.$router.push("/editBaseInfo");
    },
    editInfo(type) {
      this.editVisible = true;
      this.editType = type;
      switch (type) {
        case "mobilePhone":
          this.editTitle = "修改账号";
          this.edit_disabled = true;
          break;
        case "password":
          this.editTitle = "修改密码";
          this.edit_disabled = true;

          break;
        case "baseInfo":
          this.editTitle = "修改基本信息";
          this.edit_disabled = this.personalInfo1.name ? false : true;
          break;
      }
      setTimeout(() => {
        this.$refs.form.clearValidate();
      }, 0);
    },
    getOrderList() {
      apiGetOrderList().then(res => {
        if (res.success) {
          let temp = [];
          res.data.forEach((item, index) => {
            item.isShow = false;
            if (!this.activeOrder && index === 0) {
              this.activeOrder = item.orderNo;
            }
            try {
              item.orderDetails = JSON.parse(item.configure);
              temp.push(item);
            } catch (error) {
              console.log(error);
            }
          });
          this.list = temp;
        }
      });
    },
    getInfo() {
      apiGetAccount().then(res => {
        if (res.success) {
          this.$store.commit("edit_user", {
            ...this.$store.state.user,
            ...res.data
          });
          this.personalInfo = { ...res.data };
          this.personalInfo1 = {
            ...res.data,
            code: "",
            password: "",
            new_password: "",
            again_new_password: "",
            new_mobilePhone: ""
          };
        }
      });
    },
    getCode() {
      let pattern = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!pattern.test(this.personalInfo1.mobilePhone)) {
        toast("请填写正确的手机号码", "error");
        return;
      }
      apiSendCode(this.personalInfo1.mobilePhone).then(res => {
        if (res.success) {
          clearInterval(timeId);
          this.showCountDown = true;
          timeId = setInterval(() => {
            this.countDown = this.countDown - 1;
            if (this.countDown < 1) {
              this.countDown = 60;
              this.showCountDown = false;
              clearInterval(timeId);
            }
          }, 1000);
        }
      });
    },
    getCode1() {
      let pattern = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!pattern.test(this.personalInfo1.new_mobilePhone)) {
        toast("请填写正确的手机号码", "error");
        return;
      }
      apiSendCode(this.personalInfo1.new_mobilePhone).then(res => {
        if (res.success) {
          clearInterval(timeId);
          this.showCountDown = true;
          timeId = setInterval(() => {
            this.countDown = this.countDown - 1;
            if (this.countDown < 1) {
              this.countDown = 60;
              this.showCountDown = false;
              clearInterval(timeId);
            }
          }, 1000);
        }
      });
    },
    inputClick(value) {
      setTimeout(function() {
        document.getElementById(value).scrollIntoView(false);
      }, 500);
    },
    setIsShow(index) {
      this.list[index].isShow = !this.list[index].isShow;
    },
    edit_save() {
      this.$refs.form.validate(success => {
        if (success) {
          var that = this;
          const { new_mobilePhone, password, code } = that.personalInfo1;
          switch (that.editType) {
            case "mobilePhone":
              apiUpdateMobilePhone({
                mobilePhone: new_mobilePhone,
                password,
                code
              }).then(res => {
                if (res.success) {
                  toast("操作成功", "success");
                  that.personalInfo1.code = "";
                  that.personalInfo = {
                    ...that.personalInfo,
                    mobilePhone: that.personalInfo1.new_mobilePhone
                  };
                  that.$store.commit("edit_user", {
                    ...that.$store.state.user,
                    mobilePhone: that.personalInfo1.new_mobilePhone
                  });
                  that.handleCancel();
                }
              });
              break;
            case "baseInfo":
              apiUpdateAccount({
                ...that.personalInfo1,
                mobilePhone: that.personalInfo1.new_mobilePhone
              }).then(res => {
                if (res.success) {
                  toast("操作成功", "success");
                  that.personalInfo1.code = "";
                  that.personalInfo = { ...that.personalInfo1 };
                  that.$store.commit("edit_user", {
                    ...that.$store.state.user,
                    ...that.personalInfo1
                  });
                  that.handleCancel();
                }
              });
              break;
            case "password":
              if (
                that.personalInfo1.new_password !=
                that.personalInfo1.again_new_password
              ) {
                toast("新密码不一致", "error");
                return;
              }
              apiEditPassword({
                oldPassword: that.personalInfo1.password,
                newPassword: that.personalInfo1.new_password
              }).then(res => {
                if (res.success) {
                  toast("操作成功", "success");
                  that.personalInfo1.code = "";
                  that.personalInfo = { ...that.personalInfo1 };

                  that.handleCancel();
                }
              });
              break;
            default:
              break;
          }
        }
      });
    },
    saveInfo() {
      let fault = false;
      Object.keys(this.personalInfo1).forEach(item => {
        if (!this.personalInfo1[item]) {
          fault = true;
        }
      });
      if (fault) {
        toast("请补全信息", "error");
        return;
      }
      apiUpdateAccount(this.personalInfo1).then(res => {
        if (res.success) {
          toast("操作成功", "success");
          this.edit = false;
          this.personalInfo1.code = "";
          this.personalInfo = { ...this.personalInfo1 };
          this.$store.commit("edit_user", {
            ...this.$store.state.user,
            ...this.personalInfo1
          });
        }
      });
    },
    handleCancel() {
      this.personalInfo1 = {
        ...this.personalInfo,
        code: "",
        password: "",
        new_password: "",
        again_new_password: "",
        new_mobilePhone: ""
      };
      this.countDown = 60;
      this.showCountDown = false;
      this.editVisible = false;
    },
    onChangeProvince(data) {
      this.personalInfo1.province = data.value;
    },
    onChangeCity(a) {
      this.personalInfo1.city = a.value;
    },
    onChangeArea(a) {
      this.personalInfo1.area = a.value;
    },

    goBuy() {
      this.$router.push("/buy");
    },
    loginOut() {
      this.$store.commit("edit_user", "");
      window.location.reload();
    }
  },

  mounted() {
    setTimeout(() => {
      if (this.$store.state.isMobile) {
        this.$store.commit("edit_showTop", false);
      }
      this.getInfo();
      this.getOrderList();
      console.log(this.isMobile);
      store.commit("edit_backgroundColor", this.isMobile ? "#fff" : "#3e3e3e");
    }, 0);
  },
  destroyed() {
    clearInterval(timeId);
    store.commit("edit_backgroundColor", "rgba(0, 0, 0, 1)");
  }
};
</script>
<style lang="less">
@import url("../../less/orderInfo.less");
.orderInfo {
  max-width: 1020px;
  padding: 122px 16px 24px;
  margin: 0 auto;
  .editDialog {
    .title {
      font-size: 24px;
      margin-bottom: 12px;
    }
    .footer {
      padding-top: 24px;
      text-align: right;
    }
    .confirm {
      background-color: #fc9900;
      border-color: #fc9900;
      color: #fff;
    }
    .is-disabled {
      opacity: 0.5;
    }
    button {
      width: 92px;
    }
    .el-dialog__header {
      padding: 0;
    }
    .el-form-item__label {
      padding: 8px 0;
      line-height: 20px;
    }
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-input__inner {
      background: #f6f6f6;
      border: none;
    }

    select {
      border: none;
      background: #f6f6f6;
    }
  }
  .el-collapse-item__arrow.el-icon-arrow-right {
    transform: rotate(-90deg);
  }
  .el-collapse-item__arrow.is-active {
    transform: rotate(90deg);
  }
  .personalContainer {
    width: 550px;
    margin: 0 auto;
    .editClass {
      width: 13px;
      height: 13px;
      float: right;
      transform: translate(0, 4px);
      cursor: pointer;
    }
    .info {
      padding: 16px 24px;
      background: #f6f6f6;
      .noInfo {
        color: rgba(0, 0, 0, 0.4);
      }
      .item {
        display: flex;
        margin-bottom: 16px;
        .label {
          width: 110px;
        }
        .value {
          flex: 1;
        }
      }
      .item:last-child {
        margin-bottom: 0;
      }
    }
  }

  .personalInfo {
    margin-bottom: 8px;
    .title {
      float: left;
      font-size: 20px;
    }
    .edit {
      float: right;
      transform: translate(0, 6px);
      cursor: pointer;
    }
    .editBtn {
      width: 60px;
      height: 28px;
      line-height: 28px;
      cursor: pointer;
      background: rgba(216, 216, 216, 0);
      border: 1px solid #3e3e3e;
      color: #3e3e3e;
      text-align: center;
      margin-left: 8px;
      float: right;
    }
  }
  .list {
  }
  .noOrder {
    height: 54px;
    background: #f6f6f6;
    font-size: 16px;
    text-align: center;
    line-height: 54px;
    .goBuy {
      cursor: pointer;
      color: #fc9900;
    }
  }
  .first_column {
    padding-left: 14px;
  }
  .last_column {
    padding-right: 14px;
  }
  .content {
    display: flex;
    .left {
      flex: 1;
      border-right: 1px solid #d8d8d8;
      display: flex;
      align-items: center;
    }
    .right {
      flex: 1;
      .tableTitle,
      .tableCol {
        padding: 10px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .item:first-child {
          padding-left: 24px;
          width: 120px;
        }
        .item:nth-child(2) {
          padding-right: 24px;
          width: 120px;
          text-align: right;
        }
        .item:nth-child(3) {
          overflow: hidden;
        }
      }
      .price {
        display: flex;
        font-size: 16px;
        .label {
          flex: 1;
        }
        .value {
          flex: 1;
          text-align: right;
        }
      }
    }
  }

  .el-collapse-item__header {
    background: #f6f6f6;
    border: 1px solid #d8d8d8;
    border-top: none;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
  }
  .el-collapse-item__wrap {
    border: 1px solid #d8d8d8;
    border-top: none;
  }
  .top {
    padding-bottom: 24px;
    border-bottom: 1px solid #d8d8d8;
    color: #000;
    margin-bottom: 40px;
    .title {
      font-size: 24px;
    }
    .info {
      text-align: right;
      padding-top: 10px;
    }
    .infoBtn {
      cursor: pointer;
      padding: 4px 14px;
    }
    .pc_active {
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.85);
      font-weight: 700;
    }
  }
  .el-input-group__append {
    background-color: #f6f6f6;
    width: 110px;
    border: none;
    position: relative;
    .codeLabel {
      padding-left: 20px;
      line-height: 28px;
      border-left: 1px solid rgba(216, 216, 216, 1);
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
